import { MyTreatmentPlanTemplates } from "@/modules/admin/treatment/my-treatment-plan-templates"

const TreatmentPlanTemplates = () => {
  return <MyTreatmentPlanTemplates />
}

export { TreatmentPlanTemplates }
